// src/pages/maxLoginScreen/MaxLoginScreen.tsx
import React from "react";
import { useTheme } from "../../common/hooks/useTheme";

import styles from "./MaxLoginScreen.module.scss";
import BackButton from "../../common/components/backButton/BackButton";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

export default function MaxLoginScreen() {
  const { theme } = useTheme();

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta/>
      <div className={styles.header}>
        <BackButton />
      </div>

      <div className={styles.content}>
        <h1 className={styles.title} style={{ color: theme.text }}>
          MAX авторизация
        </h1>
        <p className={styles.subtitle} style={{ color: theme.textSecondary }}>
          Здесь будет реализован новый способ входа
        </p>
        <div
          className={styles.placeholder}
          style={{ color: theme.textSecondary }}
        >
          🚧 В разработке
        </div>
      </div>
    </div>
  );
}
